package one.primehealth.analytics

import one.healthium.domain.user.UserModel

actual class AppAnalyticsPlatform {
    actual suspend fun updateUser(user: UserModel) {
        // not used for web target
    }
}